<template>
  <div>
    <StandardCard :title="value.title" subheader="INFO" :loading="loading">
      <template v-slot>
        <div v-if="loading" class="text-center pb-4">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-else>
          <CardContent v-model="data" />
          <CardContentDesc
            v-if="value"
            descTitle="Beskrivelse"
            :text="value.description"
          />
        </div>
      </template>
    </StandardCard>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";
import CardContentDesc from "@/components/shared/cards/children/CardContentDesc.vue";

export default Vue.extend({
  name: "UserCard",
  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    data() {
      var profileItems = [
        {
          icon: "mdi-folder-pound-outline",
          title: "Id",
          content: this.value.id,
        },
        {
          icon: "mdi-account-tie-outline",
          title: "Ansvarlig",
          content: this.value.responsible,
        },
        // {
        //   icon: "mdi-account-outline",
        //   title: "Behandlet av",
        //   content: "Truls Magne",
        // },
        {
          icon: "mdi-autorenew",
          title: "Status",
          content: this.value.statusText,
        },
        {
          icon: "mdi-calendar-alert",
          title: "Frist",
          content: this.value.timeLimit
            ? moment(this.value.timeLimit).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-clipboard-edit-outline",
          title: "Rapportert av",
          content: this.value.createdBy,
        },
        {
          icon: "mdi-calendar",
          title: "Rapportert dato",
          content: this.value.createdDate
            ? moment(this.value.createdDate).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-fire",
          title: "Alvorlighetsgrad",
          content: this.value.aberrationSeverity,
        },
      ];

      return profileItems;
    },
  },

  components: {
    StandardCard,
    CardContent,
    CardContentDesc,
  },
});
</script>
